import React, { useEffect, useRef, useState } from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import Rules from "./Rules";
import Layers from "./Layers";
import PlacholderImg from "../../../assets/images/Placeholder-Img.png";
import { connect } from "react-redux";
import * as ruleAction from "../../../actions/ruleAction";
import * as dataDescriptionAction from "../../../actions/dataDescriptionAction";
import CustomButton from "./CustomButton";
import SearchableList from "./SearchableList";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";
import {
  validateDrawingRules,
  validateLayersRules,
} from "../../../utilities/applicationutils";
import * as miscAction from "../../../actions/miscAction";

var CONTROLS_DATA = require("../../../screens/ControlsData.json");

const RulesandLayers = ({
  title,
  rules,
  getDrawingRules,
  getDrawingLayers,
  getDataDescriptions,
  keepChangeRulesInState,
  viewName = "",
  isUnsaveChanges = false,
  setIsUnsaveChanges = (d) => {},
  drawings = [],
  rulesState,
  viewsState,
  intl,
  setSnackBar,
}) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      padding: "16px 32px 24px",
      marginTop: "54px",
      minWidth: "1240px",
      paddingTop: "5px",
    },
    topDiv: {
      display: "flex",
      justifyContent: "left",
      alignItems: "center",
      gap: "16px",
      paddingBottom: "5px",
      borderBottom: "1px solid var(--Brand-color-Light-Grey, #E5E7ED)",
    },
    heading: {
      fontSize: "14px",
      fontWeight: "700",
      color: "var(--Dark, #333)",
    },
    gridField: {
      marginBottom: "8px",
    },
    deleteBtn: {
      cursor: "pointer",
    },
    tabItemRules: {
      minWidth: "40%",
      maxWidth: "40%",
    },
    tabItemLayers: {
      minWidth: "55%",
      maxWidth: "55%",
    },
  }));

  const classes = useStyles();
  const [tabs, setTab] = useState(CONTROLS_DATA.SCREENS.DRAWING_TAB_NAMES);
  const [selectedTab, setSelectedTab] = useState(0);
  const [keepRules, setKeepRules] = useState([]);
  const [drawingOptions, setDrawingOptions] = useState([]);
  const [selectedCopyDrawing, setSelectedCopyDrawing] = useState("");
  const [backupRules, setBackupRules] = useState(null);
  const [backupLayers, setBackupLayers] = useState(null);
  const [backupDrawingId, setBackupDrawingId] = useState("");
  const [copyState, setCopyState] = useState({
    origin: "",
    data: "",
  });

  useEffect(() => {
    let temp = [];
    const viewData = {};
    const { data = [] } = viewsState?.views;

    if (data.length) {
      data.forEach((viewEle) => {
        const { viewName = "", viewId = "" } = viewEle;
        viewData[viewId] = viewName;
      });

      drawings.forEach((ele) => {
        temp.push({
          label: `${ele.drawingName}`,
          secondaryLabel: viewData[ele?.viewId] || "",
          drawingId: ele.drawingId,
        });
      });
      setDrawingOptions(temp);
    }
  }, [drawings, viewsState]);

  useEffect(() => {
    getDrawingRules(rules?.drawingId);
    getDrawingLayers(rules?.drawingId);
    if (!backupDrawingId) setBackupDrawingId(rules?.drawingId);
  }, [rules?.drawingId]);

  useEffect(() => {
    if (selectedCopyDrawing?.drawingId) {
      getDrawingRules(selectedCopyDrawing?.drawingId);
      getDrawingLayers(selectedCopyDrawing?.drawingId);
      // console.log(selectedCopyDrawing);
    }
  }, [selectedCopyDrawing]);

  useEffect(() => {
    getDataDescriptions(rules?.modelId);
  }, [rules?.modelId]);

  const onTabSelected = () => {
    if (selectedTab === 0) {
      setSelectedTab(1);
    } else {
      setSelectedTab(0);
    }
    keepChangeRulesInState(keepRules);
  };

  const getContainer = () => {
    return (
      <div style={{ display: "flex", gap: "20px" }}>
        <div className={classes.tabItemRules}>
          <Rules
            rules={rules}
            setIsUnsaveChanges={(data) => {
              setIsUnsaveChanges(true);
              setKeepRules(data);
            }}
            setKeepRules={setKeepRules}
            copyDrawing={selectedCopyDrawing}
            backupRules={backupRules}
            copyState={copyState}
            setCopyState={setCopyState}
          />
        </div>
        <div style={{ width: "5%", overflow: "hidden", marginTop: "-30px" }}>
          <div
            style={{
              borderRight: "1px solid #E5E7ED",
              height: "85%",
              margin: "60px auto",
              width: "2px",
            }}
          />
        </div>
        <div className={classes.tabItemLayers}>
          <Layers
            rules={rules}
            title={title}
            setIsUnsaveChanges={setIsUnsaveChanges}
            copyDrawing={selectedCopyDrawing}
            backupDrawingId={backupDrawingId}
            // backupLayers={backupLayers}
            copyState={copyState}
            setCopyState={setCopyState}
            drawingName={title}
          />
        </div>
      </div>
    );
  };

  const titleOverflowStyle = {
    maxWidth: "220px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    margin: "0px",
    marginTop: "15px",
  };

  useEffect(() => {
    if (backupRules) {
      // console.log("BackupRules: ", backupRules);
    }
  }, [backupRules]);

  return (
    <div className={classes.paper}>
      <div className={classes.topDiv}>
        <img height={"40px"} width={"40px"} src={PlacholderImg} />
        <div style={{ flex: "1" }}>
          <Tooltip title={title} arrow>
            <h2
              className={classes.heading}
              id="simple-modal-title"
              style={titleOverflowStyle}
            >
              {title}
            </h2>
          </Tooltip>

          {!!viewName && (
            <div style={{ display: "flex", width: "fit-content" }}>
              <h2
                className={classes.heading}
                id="viewname"
                style={{ fontWeight: "400", marginRight: "5px" }}
              >
                {injectIntlTranslation(
                  intl,
                  "viewNameFieldLabel",
                  constants.viewNameFieldLabel
                )}
                :
              </h2>
              <Tooltip
                title={injectIntlTranslation(intl, viewName, viewName)}
                arrow
              >
                <h2
                  className={classes.heading}
                  id="simple-viewname-title"
                  style={{
                    maxWidth: "220px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    margin: "0px",
                    marginTop: "11px",
                  }}
                >
                  {injectIntlTranslation(intl, viewName, viewName)}
                </h2>
              </Tooltip>
            </div>
          )}
        </div>
        {/* <div>Copy from another drawing</div> */}
        <div>
          <SearchableList
            title={injectIntlTranslation(
              intl,
              "copyFromAnotherDrawing",
              constants.copyFromAnotherDrawing
            )}
            top="70px"
            options={drawingOptions}
            onSelectAction={(e) => {
              const rulesInfo = [
                ...rulesState?.drawingRules?.data?.drawingRules,
              ];
              setBackupRules(rulesInfo);
              // setBackupLayers()
              setSelectedCopyDrawing(e);
            }}
          />{" "}
        </div>
      </div>
      {/* <DMTabContainer
        tabs={tabs}
        defaultActiveTab={selectedTab}
        onTabChange={onTabSelected}
        alignment={"left"}
      /> */}
      <div
        style={{
          overflow: "hidden",
          height: "calc(100vh - 200px)",
          paddingBottom: "10px",
        }}
      >
        {getContainer()}
      </div>

      <div style={{ width: "350px", margin: "auto" }}>
        <CustomButton
          id="Save-Btn"
          name={injectIntlTranslation(
            intl,
            "saveBtnLabel",
            constants.saveBtnLabel
          )}
          color="primary"
          showGradient={true}
          fullWidth
          variant="contained"
          // disabled={loading}
          onClick={async() => {
            const tempRules = window.getRuleData() || [];
            const { isError: rulesError = false } =
              validateDrawingRules(tempRules);

            const tempLayers = window.getLayersValue() || [];
            const { isError: layersError = false } =
              validateLayersRules(tempLayers);

            console.log(rulesError, layersError);

            if (rulesError === true || layersError === true) {
              setSnackBar(
                true,
                "error",
                injectIntlTranslation(
                  intl,
                  "validationErrorRules",
                  constants.validationErrorRules
                )
              );
            } else {
              await window.onRuleSave();
              await window.onLayerSave();
              setIsUnsaveChanges(false);
            }
          }}
        >
          {injectIntlTranslation(intl, "saveBtnLabel", constants.saveBtnLabel)}
        </CustomButton>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  drawingsState: state.drawing,
  rulesState: state.rules,
  viewsState: state.views,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDrawingRules: async (id) => dispatch(ruleAction.getDrawingRules(id)),
    keepChangeRulesInState: async (rules) =>
      dispatch(ruleAction.keepChangeRulesInState(rules)),
    getDrawingLayers: async (id) => dispatch(ruleAction.getDrawingLayers(id)),
    getDataDescriptions: async (requestPayload) =>
      dispatch(dataDescriptionAction.getDataDescriptions(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(RulesandLayers)
);
